module.exports = __webpack_public_path__ + "img/noposter.8572b60b.png";